import {
  GET_LOCATION_INFO,
  LOCATION_INFO_ERROR,
  GET_LOCATION_FILTER_INFO,
  LOCATION_FILTER_INFO_ERROR,
  UPDATE_TRAVEL,
  UPDATE_TRAVEL_ERROR,
  UPDATE_POSTAL_CODE,
  ADD_FAVOURITE_INFO,
  ADD_FAVOURITE_ERROR,
  LOCATION_SEARCH_ERROR,
  LOCATION_SEARCH_INFO,
} from "../types";

const initialState = {
  locationInfo: {},
  travleInfo: {},
  postCodeInfo: {},
  postCodeArray: [],
  loading: true,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_LOCATION_INFO:
      // console.log(action.payload);
      return {
        ...state,
        locationInfo: action.payload,
        loading: false,
      };
    case LOCATION_INFO_ERROR:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_TRAVEL:
      // console.log(action.payload, '+++');
      return {
        ...state,
        travleInfo: action.payload,
        loading: false,
      };
    case UPDATE_TRAVEL_ERROR:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_POSTAL_CODE:
      // console.log(action.data, "action");
      return {
        ...state,
        postCodeInfo: action.payload,
        postCodeArray: action.data,
        loading: false,
      };
    case UPDATE_TRAVEL_ERROR:
      return {
        ...state,
        loading: true,
      };
    case LOCATION_SEARCH_INFO:
      // console.log(action.loading, "action");
      return {
        ...state,
        postCodeInfo: action.payload,
        loading: action.loading?action.loading :false,
      };
    case LOCATION_SEARCH_ERROR:
      return {
        ...state,
        loading: action.loading?action.loading:true,
      };
    case ADD_FAVOURITE_INFO:
      return {
        ...state,
        favouriteInfo: action.payload,
        loading: false,
      };
    case ADD_FAVOURITE_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
